/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const RightUpArrowIcon = ({
  className,
  style,
  color = '#BCE6FF',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0766 69.3281C40.2564 69.2315 49.9221 68.0518 58.8662 65.6651C60.8003 65.0674 60.0832 62.1737 58.0286 62.6501C50.052 64.5573 41.9564 65.7412 33.7421 66.0813C25.5282 66.4215 14.5365 66.5131 8.15068 60.5918C4.89744 57.5708 5.03238 52.1485 4.80132 48.051C4.4547 42.0248 4.59153 35.8797 4.96961 29.8555C5.22691 23.8311 5.84687 17.6871 6.58729 11.6639C6.95813 8.41127 8.78371 3.11392 7.22109 0.217774C7.10114 -0.0235449 6.73879 -0.024491 6.6175 0.0956949C3.83385 2.25747 3.93858 8.40338 3.44696 11.6557C2.46182 18.8833 1.96013 25.9916 1.5789 33.2208C1.19358 42.0163 -0.654213 55.7487 5.97075 62.7552C11.7518 69.1571 23.105 69.3073 31.0766 69.3281Z"
        fill={color}
      />
      <path
        d="M69.1287 66.7765C70.3387 65.9362 70.1009 64.4895 68.7739 63.8835C64.6717 62.186 60.9344 59.5251 56.8322 57.8272C55.6256 57.342 55.017 59.148 55.9817 59.753C59.117 61.6892 62.2526 63.505 65.3879 65.4412C64.4204 65.9207 63.4529 66.4002 62.4853 66.8799C60.9136 67.4783 59.3431 67.5947 57.8918 68.3139C56.8035 68.7929 57.2829 70.2404 58.1274 70.6041C61.5062 71.8177 66.3456 68.6973 69.1287 66.7765Z"
        fill={color}
      />
    </svg>
  );
};
